import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for the My Website builder (/studio). Anchors live in StudioBuilder.tsx. */
export function getStudioTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'Build your website',
        description:
          "This is your website builder. Here's a quick tour of how to create and edit your " +
          'site — you can stop anytime.',
      },
    },
    {
      element: at('studio-chat'),
      popover: {
        title: 'Ask the AI',
        description:
          'Tell the AI what you want in plain English — “add a section about me”, “use navy and ' +
          'gold”, “show my listings”. It builds and edits the page for you.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: at('studio-tabs'),
      popover: {
        title: 'Three ways to work',
        description:
          'Switch between AI Chat (talk to build), Structure (manage pages and sections), and ' +
          'Edit (fine-tune one section at a time).',
        side: 'right',
        align: 'start',
      },
    },
    {
      element: at('studio-page-selector'),
      popover: {
        title: 'Pick a page',
        description: 'Choose which page you’re editing — home, listings, about, and so on.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('studio-preview'),
      popover: {
        title: 'Live preview',
        description:
          'Your site updates here in real time as you build. Click any section in the preview to ' +
          'edit it directly.',
        side: 'left',
        align: 'center',
      },
    },
    {
      element: at('studio-device-toggle'),
      popover: {
        title: 'Check mobile',
        description:
          'Switch between desktop and phone views. Always check the phone view — most buyers visit ' +
          'on mobile.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('studio-publish'),
      popover: {
        title: 'Publish when ready',
        description:
          'Your edits stay private until you click Publish. Nothing goes live until you say so — ' +
          'so feel free to experiment.',
        side: 'bottom',
        align: 'end',
      },
    },
  ];
}
